module.exports = __webpack_public_path__ + "img/it.e894cde7.png";